import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth doit être utilisé dans un AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('hb9g_token');
    const savedUser = localStorage.getItem('hb9g_user');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      authAPI.getProfile()
        .then(response => {
          setUser(response.data);
          localStorage.setItem('hb9g_user', JSON.stringify(response.data));
        })
        .catch(() => {
          logout();
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('hb9g_token', token);
    localStorage.setItem('hb9g_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('hb9g_token');
    localStorage.removeItem('hb9g_user');
    setUser(null);
  };

  const updateUser = (userData) => {
    localStorage.setItem('hb9g_user', JSON.stringify(userData));
    setUser(userData);
  };

  const isAuthenticated = !!user;
  const isComite = user?.role === 'comite' || user?.role === 'admin';
  const isAdmin = user?.role === 'admin';

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      isAuthenticated,
      isComite,
      isAdmin,
      login,
      logout,
      updateUser
    }}>
      {children}
    </AuthContext.Provider>
  );
};
